export const EXTRA_DATA_LABELS: Record<string, string> = {
  dni: 'DNI',
  edad: 'Edad',
  fecha_nacimiento: 'Fecha Nacimiento',
  domicilio: 'Domicilio',
  obra_social: 'Obra Social',
  nro_afiliado: 'Nro Afiliado',
  motivo_consulta: 'Motivo Consulta',
};

export const formatExtraValue = (key: string, value: any): string => {
  if (key === 'fecha_nacimiento' && value) {
    const parts = String(value).split('-');
    if (parts.length === 3) return `${parts[2]}/${parts[1]}/${parts[0]}`;
  }
  return String(value);
};

export const getExtraLabel = (key: string): string => {
  return EXTRA_DATA_LABELS[key] || key.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase());
};
